const donationForm = $('form[id*=spendenformular-]');
const companionForm = $('form[id*=mkg_companion]');

function togglePaymentFieldsets(formID) {
    const form = $('form[id*='+ formID +']')
    let sepaFieldset = form.find('fieldset[id^="'+ formID +'"][id$="-sepa"]');
    let accountHolderField = sepaFieldset.find('input[id^='+ formID +'][id$=-account-holder]');
    let ibanField = sepaFieldset.find('input[id^='+ formID +'][id$=-iban]');
    let bicField = sepaFieldset.find('input[id^='+ formID +'][id$=-bic]');
    let bankTransferFieldset = form.find('fieldset[id^="'+ formID +'"][id$="-bank-transfer"]');
    sepaFieldset.hide();
    bankTransferFieldset.hide();
    let paymentMethodField = form.find('select[id^="'+ formID +'"][id$="-payment-method"]');

    paymentMethodField.on('change', (e) => {
        accountHolderField.prop('required',false);
        ibanField.prop('required',false);
        bicField.prop('required',false);

        switch ($(e.target).val()) {
            case "SEPA-Lastschrift":
                // show sepa
                sepaFieldset.show();

                accountHolderField.prop('required', true);
                ibanField.prop('required', true);
                bicField.prop('required', true);

                bankTransferFieldset.hide();
                break;
            case "Überweisung":
                // show payment
                sepaFieldset.hide()
                bankTransferFieldset.show();
                break;
            default:
                sepaFieldset.hide()
                bankTransferFieldset.hide();
        }
    });
}

if (companionForm.length > 0) {
    togglePaymentFieldsets('mkg_companion');
}
if (donationForm.length > 0) {
    togglePaymentFieldsets('spendenformular');

    let donationCertificateFieldset = donationForm.find('fieldset[id^="spendenformular"][id$="-donation-certificate"]');
    let donationSalutation = donationCertificateFieldset.find('input[id$="-salutation"]');
    let donationFirstNameField = donationCertificateFieldset.find('input[id$="-first-name"]');
    let donationLastNameField = donationCertificateFieldset.find('input[id$="-last-name"]');
    let donationStreetField = donationCertificateFieldset.find('input[id$="-street"]');
    let donationHousenumberField = donationCertificateFieldset.find('input[id$="-housenumber"]');
    let donationZipField = donationCertificateFieldset.find('input[id$="-zip"]');
    let donationCityField = donationCertificateFieldset.find('input[id$="-city"]');
    donationCertificateFieldset.hide();

    donationForm.find('[name*="[donation-certificate]"]').on('change', (e) => {
        let setRequired = false;
        if ($(e.target).attr('id').split('-').slice(-1)[0] == 1) {
            donationCertificateFieldset.show();
            setRequired = true;
        } else {
            donationCertificateFieldset.hide();
        }

        donationSalutation.prop('required', setRequired);
        donationFirstNameField.prop('required', setRequired);
        donationLastNameField.prop('required', setRequired);
        donationStreetField.prop('required', setRequired);
        donationHousenumberField.prop('required', setRequired);
        donationZipField.prop('required', setRequired);
        donationCityField.prop('required', setRequired);
    });
}
